import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import ScheduleGradeAircraftLineBase from './ScheduleGradeAircraftLineBase';
import ScheduleGradeAircraftLineAircraft from './ScheduleGradeAircraftLineAircraft';
import ScheduleGradeAircraftLinePeriod from './ScheduleGradeAircraftLinePeriod';
import ScheduleGradeAircraftLineGroup from './ScheduleGradeAircraftLineGroup';
import ScheduleGradeAircraftLineCrew from './ScheduleGradeAircraftLineCrew';
import ScheduleGradeAircraftLineDays from './ScheduleGradeAircraftLineDays';
import getLocale from '../../../i18n/getLocale';

class ScheduleGradeAircraftLine extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      edit_mode: this.props.edit_mode,
      sgas: {},
      toggled: 0,
      line_style: {
        0: {background: '#D6B953', fontWeight: 'bold'},
        1: {background: '#F5D76E', fontWeight: 'bold'},
      },
    };

    this.locale = getLocale();

    //bind específico
    this.toggleAllSelect = this.toggleAllSelect.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      sgas: newProps.sgas,
      loaded: 1,
    });
    this.setState({edit_mode: newProps.edit_mode});

  }

  toggleAllSelect() {
    this.setState({
      toggled: 1,
    });
  }



  render() {
    var self = this;
    var style_fb = { background: '#538dd5', color:  '#000'};
    if (self.state.sgas.role == 'COPIL') {
      style_fb = { background: '#fcd5b4', color:  '#000'};
    }
    if (self.state.sgas.role == 'CMS') {
      style_fb = { background: '#4bacc6', color:  '#000'};
    }
    if (self.state.sgas.graduation == 1) {
      style_fb = { background: '#c9321a', color:  '#000'};
    }
    if (self.state.sgas.graduation == 2) {
      style_fb = { background: '#c9c23e', color:  '#000'};
    }
    if (self.state.sgas.graduation == 3) {
      style_fb = { background: '#3da632', color:  '#000'};
    }



    return (
  <tr>
    <td className={"text-center table-schedule-sticky schedule-small-editable table-schedule-main-base-" + self.props.zoom_level} style={self.state.line_style[self.state.sgas.color]}>
      <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />
      <ScheduleGradeAircraftLineBase schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id} updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} staff={self.state.sgas.staff} base_id={self.state.sgas.base_id} base_name={self.state.sgas.base} sga_id={self.state.sgas.sga_id} bases_active_list={self.props.bases_active_list} edit_mode={self.state.edit_mode} toggleEditMode={self.props.toggleEditMode} changeBaseId={self.props.changeBaseId} />
    </td>
    <td className={"text-center table-schedule-sticky schedule-small-editable table-schedule-main-act-" + self.props.zoom_level} style={self.state.line_style[self.state.sgas.color]}>
      <ScheduleGradeAircraftLineAircraft schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id} updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} staff={self.state.sgas.staff} aircraft_id={self.state.sgas.aircraft_id} aircraft_name={self.state.sgas.aircraft} sga_id={self.state.sgas.sga_id} aircrafts_list={self.props.aircrafts_list} sgas_id={self.state.sgas.sgas_id} edit_mode={self.state.edit_mode} toggleEditMode={self.props.toggleEditMode} changeAircraftAll={self.props.changeAircraftAll} changeAircraftSingle={self.props.changeAircraftSingle} alert_level={self.state.sgas.sga_alert_level} generateAircraftAlerts={self.props.generateAircraftAlerts}  />
      <br/>
      {self.state.edit_mode && <button className="btn btn-danger btn-xs btn-inline" onClick={() => this.props.deleteAircraft(self.state.sgas.sga_id)}><i className="fa fa-fw fa-trash"></i></button>}
      {self.state.edit_mode && <button className="btn btn-primary btn-xs btn-inline" onClick={() => this.props.addLine(self.state.sgas.sga_id)}><i className="fa fa-fw fa-plus"></i></button>}
    </td>
    <td className={"text-center table-schedule-sticky table-schedule-main-del-" + self.props.zoom_level}>
      {self.state.edit_mode && <button className="btn btn-danger btn-xs" onClick={() => this.props.deleteLine(self.state.sgas.sgas_id)}><i className="fa fa-trash"></i></button>}
    </td>

    <ScheduleGradeAircraftLinePeriod schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id} updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} schedule_used_regime_id={self.state.sgas.schedule_used_regime_id} sgas_id={self.state.sgas.sgas_id} sga_id={self.state.sgas.sga_id} base_id={self.state.sgas.base_id} staff_id={self.state.sgas.staff_id} edit_mode={self.state.edit_mode} toggleEditMode={self.props.toggleEditMode} changePeriodUpdate={self.props.changePeriodUpdate} changePeriodSimple={self.props.changePeriodSimple} cancelChangePeriod={self.props.cancelChangePeriod} zoom_level={self.props.zoom_level} />

    <ScheduleGradeAircraftLineGroup schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id} updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} line={self.state.sgas.line} sgas_id={self.state.sgas.sgas_id} edit_mode={self.state.edit_mode} toggleEditMode={self.props.toggleEditMode} changeGroup={self.props.changeGroup} zoom_level={self.props.zoom_level} />
    <ScheduleGradeAircraftLineCrew schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id} updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} staff={self.state.sgas.staff} staff_id={self.state.sgas.staff_id} sgas_id={self.state.sgas.sgas_id} alert_level={self.state.sgas.alert_level} remaining_staffs_list={self.props.remaining_staffs_list} schedule_used_regime_list={self.props.schedule_used_regime_list} schedule_used_regimes={self.props.schedule_used_regimes} staffs_list={self.props.staffs_list} style_fb={style_fb} edit_mode={self.state.edit_mode} toggleEditMode={self.props.toggleEditMode} generatePersonalAlerts={self.props.generatePersonalAlerts} changeStaffIdToNT={self.props.changeStaffIdToNT} changeStaffId={self.props.changeStaffId} addStaffWithPeriod={self.props.addStaffWithPeriod} zoom_level={self.props.zoom_level} />
    {(self.state.sgas.inscription !== null) ? 
      <td className={"text-center table-schedule-sticky table-schedule-main-inscription-" + self.props.zoom_level} style={style_fb}>{self.state.sgas.inscription}</td>
      :
      <td className={"text-center table-schedule-sticky table-schedule-main-inscription-" + self.props.zoom_level}>Indisp.</td>
    }
    {(self.state.sgas.role !== null) ? 
      <td className={"text-center table-schedule-sticky table-schedule-main-designation-" + self.props.zoom_level} style={style_fb}>{self.state.sgas.role}</td>
      :
      <td className={"text-center table-schedule-sticky table-schedule-main-designation-" + self.props.zoom_level}>Indisp.</td>
    }
    {Object.keys(self.props.schedule_days).map(function(k) {
      var day = self.props.schedule_days[k];
      if (typeof self.state.sgas.days !== 'undefined') {
        if (typeof self.state.sgas.days[day.day] !== 'undefined') {
          return(
            <ScheduleGradeAircraftLineDays schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id} updateData={self.props.updateData} toggleAllSelect={self.toggleAllSelect} updated={self.props.updated} handleAlert={self.props.handleAlert} initials_colors={self.props.initials_colors} types_list={self.props.types_list} sgas_id={self.state.sgas.sgas_id} toggled={self.state.toggled} day={self.state.sgas.days[day.day]} edit_mode={self.state.edit_mode} toggleEditMode={self.props.toggleEditMode} date={day.day} changeDateType={self.props.changeDateType} zoom_level={self.props.zoom_level} cloneDay={self.props.cloneDay} />
          );
        } else {
          return(
            <td style={{background: 'blue'}}>&nbsp;</td>
          );
        }
        return('');
      }
    })}

  </tr>
    );
  }
}

export default ScheduleGradeAircraftLine;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAircraftLine.js